import { render, staticRenderFns } from "./RankItem.vue?vue&type=template&id=fb2b508e&scoped=true"
import script from "./RankItem.vue?vue&type=script&lang=js"
export * from "./RankItem.vue?vue&type=script&lang=js"
import style0 from "./RankItem.vue?vue&type=style&index=0&id=fb2b508e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2b508e",
  null
  
)

export default component.exports